module.exports = __webpack_public_path__ + "static/media/logo.b0c9e7b0.png";